/**
 * `productArea` for asset modal people-tagging events: reflects host resource (Brandfolder, Collection, etc.).
 */
export function resolvePeopleTaggingHostProductArea(): string {
  const raw = window.BFG?.resource?.type;
  if (raw === 'collection') {
    return 'Collection';
  }
  if (raw === 'brandfolder') {
    return 'Brandfolder';
  }
  if (raw === 'workspace') {
    return 'Workspace';
  }
  return raw ? String(raw) : 'Brandfolder';
}
